import { Navigate } from 'react-router-dom';
import { isAdminLoggedIn } from './adminApi';

export default function AdminGuard({ children }) {
  if (!isAdminLoggedIn()) {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
}
